import React from 'react';
import styled from 'styled-components';
import Union from '../../components/svg/Union';
import { responsive } from '../../resources/constantes.json';

const InfoCurules = ({ cargos, cargEmpatados, color }) => {
  return (
    <Container cargos={cargos}>
      {cargos !== 0 && (
        <>
          <Curules>
            <Cargos>{cargos}{cargEmpatados && cargEmpatados !== "0" ? "*": ""}</Cargos>
            <Union color={color} />
          </Curules>
        </>
      )}
    </Container>
  );
};

export default InfoCurules;

const Container = styled.div`
  display: flex;
  visibility: ${({ cargos }) => (cargos === 0 ? 'hidden' : 'visible')};
  margin-left: 1rem;
  flex-direction: column;
  justify-content: space-around;
  width: 51px;
  span {
    text-align: center;
  }
  svg {
    margin-left: 10px;
    height: 20px;
  }
`;

const Curules = styled.div`
  display: flex;
  width: 100%;
  justify-content: end;
`;

const Cargos = styled.span`
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
`;
